<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="headerIcon()"
	[headerText]="participantType() | enumLabel: EnumLabel.ExamParticipant"
	[matDialogData]="data"
	[rect]="rect"
>
	<form dialogContent>
		<sim-chip-autocomplete
			[dataType]="FetchDataType.SimUser"
			[formCtrl]="formCtrl"
			[labelToken]="participantType() | enumLabel: EnumLabel.ExamParticipant"
			subscriptSizing="dynamic"
		>
			<mat-icon [fontIcon]="headerIcon().fontIcon" [fontSet]="headerIcon().fontSet" labelPrefix />
		</sim-chip-autocomplete>
		<button #submit (click)="doSubmit()" hidden></button>
	</form>
	<ng-container actions>
		<sim-button
			[appBusy]="busyPromise()"
			(click)="submit.click()"
			[icon]="{fontIcon: 'fa-check', fontSet: 'far'}"
			[label]="T.BUTTON_SAVE"
			size="small"
		/>
	</ng-container>
</sim-basic-material-dialog>
